import * as actionTypes from 'constants/ActionTypes';

export function getCargoTagsCategories() {
    return {
        type: actionTypes.GET_CARGO_TAGS_CATEGORIES.REQUEST,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/tags.js